import React from 'react';
import { CTAButton } from './CTAButton';
import { Smartphone, Tablet, Monitor } from 'lucide-react';
export function FinalCTA() {
  return <section id="compra" className="w-full bg-white py-12 px-4 border-t-8 border-green-500" data-id="element-67">
      <div className="max-w-4xl mx-auto text-center" data-id="element-68">
        <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-8 leading-tight" data-id="element-69">
          Comienza hoy a acompañar el aprendizaje de tu hijo
        </h2>

        <div className="bg-gray-50 rounded-3xl p-8 md:p-12 border-2 border-gray-200 shadow-2xl mb-10" data-id="element-70">
          <p className="text-2xl font-bold text-gray-600 mb-6 uppercase tracking-wider" data-id="element-71">
            Obtén acceso inmediato al:
          </p>

          <div className="text-3xl md:text-4xl font-black text-blue-700 mb-4" data-id="element-72">
            📚 Kit de Aprendizaje en Casa
          </div>
          <div className="text-2xl md:text-3xl font-bold text-red-600 mb-10" data-id="element-73">
            🎁 + 3 bonos incluidos
          </div>

          <div className="flex justify-center mb-8" data-id="element-74">
            <img src="https://cdn.magicpatterns.com/uploads/bBfzVvtMW9aA2vHsqvkDe2/imagen_arriba_del_precio.png" alt="Kit de Aprendizaje en Casa con bonos" className="w-full max-w-lg h-auto object-contain" data-id="element-75" />
          </div>

          <div className="mb-6" data-id="element-76">
            <p className="text-gray-500 font-bold uppercase tracking-widest mb-2" data-id="element-77">
              Precio Especial
            </p>
            <p className="text-6xl font-black text-green-600" data-id="element-78">ARS $19,990</p>
          </div>

          <CTAButton text="ACCEDER AL KIT DE APRENDIZAJE EN CASA" href="https://checkout.aulamater.online/cart/44028495298659:1" className="w-full" data-id="element-79" />

          <div className="mt-6 flex items-center justify-center space-x-2 text-gray-500 text-sm font-medium" data-id="element-80">
            <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-81">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-82" />
            </svg>
            <span data-id="element-83">Pago 100% Seguro y Encriptado</span>
          </div>
        </div>
      </div>
    </section>;
}